import { Component as ReactComponent } from 'react';

export abstract class Component<IProps = unknown, IState = unknown> extends ReactComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {} as any;
    }

    public setState<K extends keyof IState>(
        f: (prevState: IState, props: IProps) => Pick<IState, K>,
        callback?: () => any
    ): Promise<void> | void;
    public setState<K extends keyof IState>(state: Pick<IState, K>, callback?: () => any): Promise<void> | void;
    public setState(state: any, callback?: () => any): Promise<void> | void {
        if (callback) {
            super.setState(state, callback);
        } else {
            return new Promise((resolve) => {
                super.setState(state, () => {
                    resolve();
                });
            });
        }
    }
}
